import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalConfig } from 'src/app/models/modal.config';
import { StatusMotorista } from 'src/app/models/status-motorista.model';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutComponenteService } from '../pre-checkout/pre-checkout.componente.service';
import { StateService } from 'src/app/state/state.service';
import { DisplayLoginComponents, PreCheckoutLoginService } from './pre-checkout-login.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-pre-checkout-login',
  templateUrl: './pre-checkout-login.component.html',
  styleUrls: ['./pre-checkout-login.component.css']
})
export class PreCheckoutLoginComponent implements OnInit {

  modalConfig: ModalConfig = { 
    modalTitle: ""
  };
  
  preCheckoutFormCelular = this.formBuilder.group({
    telefone: ''
  });

  translation: any;
  tentativa: number = 0;
  display: DisplayLoginComponents = new DisplayLoginComponents();
  @ViewChild('modalAlterarTelefone') private modalAlterarTelefoneComponent: ModalComponent
  statusMotorista: StatusMotorista = new StatusMotorista();

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private checkoutService: PreCheckoutComponenteService,
              private alertService: AlertService,
              private translate: TranslateService,
              private stateService: StateService,
              private loginService: PreCheckoutLoginService) { }

  onSubmit(): void {
    if (this.validFormCelular){
      this.alterarTelefone();
    }
  }

  validPhone() {
    return this.preCheckoutFormCelular.value.telefone.length==0 ||
    this.preCheckoutFormCelular.value.telefone.length == 11;
  }

  validFormCelular() {
    return this.preCheckoutFormCelular.valid;
  }

  replaceCaracterCelular(input: string){
    let value = input?.replace("(","").replace(")","").replace(" ","").replace("-","");
    return value;
  }

  podeAtualizarTelefone(): boolean
  {
      let celular = this.replaceCaracterCelular(this.statusMotorista?.detalhes?.celular);
      if(this.preCheckoutFormCelular.value.telefone && (celular!=this.preCheckoutFormCelular.value.telefone))
        return true;
      else
        return false;
  }

  alterarTelefone(){
    if(this.preCheckoutFormCelular.value.telefone.length == 11 && this.podeAtualizarTelefone()){
      this.openModalAlterarTelefone();
    }
    else if(this.preCheckoutFormCelular.value.telefone.length == 11){
      this.loginService.setDisplay(new DisplayLoginComponents(false, false, true));
      this.stateService.updatePhone(this.preCheckoutFormCelular.value.telefone);
    }
  }

  onSalvar() {
    this.loginService.setDisplay(new DisplayLoginComponents(false, true, false));
    this.stateService.updatePhone(this.preCheckoutFormCelular.value.telefone);
    return true;
  }

  onCancelar(){
    this.alertService.alertWarning("Número de celular não atualizado, prossiga com a validação do login","");
    this.loginService.setDisplay(new DisplayLoginComponents(false, false, true));
    this.stateService.updatePhone(this.preCheckoutFormCelular.value.telefone);
  }

  openModalAlterarTelefone() {
      this.modalConfig.modalTitle = "Aviso";
      this.modalConfig.closeButtonLabel = "Sim";
      this.modalConfig.dismissButtonLabel = "Não";
      this.modalConfig.shouldClose = this.onSalvar.bind(this);
      this.modalConfig.onDismiss = this.onCancelar.bind(this);

      return this.modalAlterarTelefoneComponent.open();
  }

  prosseguir(){
    //Limpa alert
    this.alertService.limpaAlertMessage();
    //Marca como concluído o estágio de login
    this.stateService.updateStageLogin(true);
    Utilitarios.NEXT_LEVEL="viagem";
    this.router.navigate(['/viagem']);

  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();

    //Após 12 horas expira a sessão
    setTimeout(function(){ window.location.href = "/start"; }, 43200000);
    
    this.loginService.getDisplay().subscribe((result)=>{
      this.display = result
    });

    this.checkoutService.get().subscribe((status)=>{
      this.statusMotorista = status;
    });

    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });
  }
}